// extracted by mini-css-extract-plugin
export default {"modalCloseIcon":"Modal_modalCloseIcon__mKrKN","modalTitle":"Modal_modalTitle__EpiB3","ant-modal-content":"Modal_ant-modal-content__Gs5hQ"};